import React, { useState } from 'react';
import { brigadeiros, bombons } from '../data/mockData';
import { Card, CardContent } from './ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Badge } from './ui/badge';

const Menu = () => {
  const [selectedCategory, setSelectedCategory] = useState('brigadeiros');

  return (
    <section id="menu" className="py-20 bg-gradient-to-b from-white to-amber-50">
      <div className="container mx-auto px-4">
        {/* Section header */}
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-amber-100 text-amber-800 hover:bg-amber-200">
            Nossos Sabores
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-amber-950 mb-4">
            Cardápio Completo
          </h2>
          <p className="text-xl text-amber-700 max-w-2xl mx-auto">
            Cada doce é preparado artesanalmente com ingredientes selecionados
          </p>
        </div>

        {/* Tabs */}
        <Tabs defaultValue="brigadeiros" className="w-full" onValueChange={setSelectedCategory}>
          <TabsList className="grid w-full max-w-md mx-auto grid-cols-2 mb-12 bg-amber-100 p-1 rounded-full">
            <TabsTrigger 
              value="brigadeiros" 
              className="rounded-full data-[state=active]:bg-amber-700 data-[state=active]:text-white transition-all duration-300"
            >
              Brigadeiros
            </TabsTrigger>
            <TabsTrigger 
              value="bombons"
              className="rounded-full data-[state=active]:bg-amber-700 data-[state=active]:text-white transition-all duration-300"
            >
              Bombons Belgas
            </TabsTrigger>
          </TabsList>

          <TabsContent value="brigadeiros" className="mt-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {brigadeiros.map((item) => (
                <Card 
                  key={item.id} 
                  className="group overflow-hidden border-2 border-amber-100 hover:border-amber-300 transition-all duration-300 hover:shadow-xl"
                >
                  <div className="relative overflow-hidden h-48 bg-amber-100">
                    <img 
                      src={item.image} 
                      alt={item.name}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-amber-900/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                  <CardContent className="p-5">
                    <h3 className="font-bold text-lg text-amber-950 mb-2 group-hover:text-amber-700 transition-colors">
                      {item.name}
                    </h3>
                    <p className="text-sm text-amber-700 leading-relaxed">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </TabsContent>

          <TabsContent value="bombons" className="mt-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {bombons.map((item) => (
                <Card 
                  key={item.id} 
                  className="group overflow-hidden border-2 border-amber-100 hover:border-amber-300 transition-all duration-300 hover:shadow-xl"
                >
                  <div className="relative overflow-hidden h-48">
                    <img 
                      src={item.image} 
                      alt={item.name}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-amber-900/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                  <CardContent className="p-5">
                    <h3 className="font-bold text-lg text-amber-950 mb-2 group-hover:text-amber-700 transition-colors">
                      {item.name}
                    </h3>
                    <p className="text-sm text-amber-700 leading-relaxed">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </section>
  );
};

export default Menu;
